// extracted by mini-css-extract-plugin
export default {"Model":"model_Model__Zyo2D","modelContainer":"model_modelContainer__COQvz","modelOptions":"model_modelOptions__lsikm"};